export default {
	messages: {
		de: {
			name: 'Name',
			actions: {
				myProfile: 'Mein Profil',
				settings: 'Einstellungen',
				logout: 'Abmelden',
			},
		},
		en: {
			name: 'Name',
			actions: {
				myProfile: 'My Profile',
				settings: 'Settings',
				logout: 'Logout',
			},
		},
	},
};
